import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { InformationFlow } from 'ThreeTerminal_mobile';
import styles from './index.css';

class Main extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        type: PropTypes.string,
        // id: PropTypes.string,
        getMoreFunc: PropTypes.func,
    };

    render() {
        const { content, type, getMoreFunc } = this.props;

        return content.length ? (
            <div className={styles.main}>
                {type === 'doc' ? (
                    <InformationFlow
                        content={content}
                        preload={false}
                        isCount={false}
                        isNewsTime={true}
                        isFormatTime={true}
                        isScrollLoadingData={true}
                        handleLoadingDataFunc={getMoreFunc}
                        isDisplayLoadingMore={false}
                    />
                ) : (
                    ''
                )}
                {type === 'video' ? (
                    <InformationFlow
                        content={content}
                        preload={false}
                        isCount={false}
                        isNewsTime={true}
                        isFormatTime={true}
                        getVideoPlayNum={false}
                        isScrollLoadingData={true}
                        handleLoadingDataFunc={getMoreFunc}
                        isDisplayLoadingMore={false}
                    />
                ) : (
                    ''
                )}
                {type === 'short' ? (
                    <InformationFlow
                        content={content}
                        preload={false}
                        isCount={false}
                        isNewsTime={true}
                        isFormatTime={true}
                        getVideoPlayNum={false}
                        isScrollLoadingData={true}
                        handleLoadingDataFunc={getMoreFunc}
                        isDisplayLoadingMore={false}
                    />
                ) : (
                    ''
                )}
            </div>
        ) : null;
    }
}

export default errorBoundary(Main);
